import type { Category } from "@/data/careers";

/** Short display labels for category facets. Underlying data keeps the full canonical names. */
export const CATEGORY_SHORT_LABELS: Record<Category, string> = {
  "Business, Finance and Legal": "Business & Finance",
  "Design and Creative": "Design & Creative",
  "Education, Science and Research": "Education & Science",
  "Engineering, Construction and Infrastructure": "Engineering & Construction",
  "Healthcare and Care": "Healthcare",
  "Hospitality and Food": "Hospitality",
  "Marketing and Media": "Marketing & Media",
  "Public Sector and Emergency Services": "Public Sector",
  "Sales, Retail and Customer Service": "Sales & Retail",
  "Self-Employed and Business Owner": "Self-Employed",
  "Skilled Trades": "Skilled Trades",
  "Sport, Fitness and Wellbeing": "Fitness & Sport",
  "Technology": "Technology",
  "Transport and Logistics": "Transport & Logistics",
  "Aviation and Aerospace": "Aviation & Aerospace",
  "Mental Health and Therapy": "Mental Health & Therapy",
  "Green Energy and Sustainability": "Green Energy",
  "Logistics and Supply Chain": "Supply Chain",
  "AI, Data and Automation": "AI, Data & Automation",
  "Beauty and Aesthetics": "Beauty & Aesthetics",
  "Maritime and Offshore": "Maritime & Offshore",
};

export const categoryLabel = (c: string): string =>
  (CATEGORY_SHORT_LABELS as Record<string, string>)[c] ?? c;
